import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {createRoot} from 'react-dom/client'
import * as serviceWorker from './serviceWorker';

import {Provider} from 'react-redux';
import {configureStore} from './redux/store';
import "./multiLanguage/multiLanguage";



// ReactDOM.render(
//     <Provider store={configureStore()}>
//         <React.StrictMode>
//             <App/>
//         </React.StrictMode></Provider>,
//     document.getElementById('root')
// );

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.

root.render(
    <Provider store={configureStore()}>
        <App />
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
